export default {
    actionMargin: '0 0 0 20px'
};
